module.exports = __webpack_public_path__ + "img/vib.cb7e83b2.png";